const codeFencePattern = /```([A-Za-z0-9_+#.-]*)[ \t]*\n([\s\S]*?)```/g;

const codeLanguageLabels = {
  md: "MARKDOWN",
  markdown: "MARKDOWN",
  latex: "LATEX",
  tex: "LATEX",
};

const codeKeywords = new Set([
  "and",
  "as",
  "async",
  "await",
  "boolean",
  "break",
  "catch",
  "class",
  "const",
  "continue",
  "def",
  "else",
  "elif",
  "export",
  "extends",
  "false",
  "finally",
  "for",
  "from",
  "function",
  "if",
  "import",
  "in",
  "int",
  "let",
  "new",
  "None",
  "not",
  "null",
  "or",
  "private",
  "public",
  "return",
  "static",
  "string",
  "super",
  "this",
  "throw",
  "true",
  "try",
  "undefined",
  "var",
  "void",
  "while",
]);

const tokenPattern =
  /(\/\/.*|\/\*.*?\*\/|#.*|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`|<\/?[A-Za-z][\w:-]*|\/?>|\b\d+(?:\.\d+)?\b|\b[A-Za-z_$][\w$]*\b|[{}()[\].,;:+\-*/%=<>!&|?]+)/g;

export const parseAiChatContentBlocks = (value) => {
  const text = String(value || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const blocks = [];
  let lastIndex = 0;

  for (const match of text.matchAll(codeFencePattern)) {
    if (match.index > lastIndex) {
      blocks.push({ type: "text", text: text.slice(lastIndex, match.index) });
    }

    blocks.push({
      type: "code",
      language: (match[1] || "").trim(),
      code: (match[2] || "").replace(/\n$/, ""),
    });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    blocks.push({ type: "text", text: text.slice(lastIndex) });
  }

  return blocks.length ? blocks : [{ type: "text", text }];
};

export const getCodeLanguageLabel = (language) =>
  codeLanguageLabels[String(language || "").trim().toLowerCase()] ||
  String(language || "code").trim().toUpperCase();

export const getCodeTokenKind = (token) => {
  if (/^(?:\/\/|#|\/\*)/.test(token)) return "comment";
  if (/^["'`]/.test(token)) return "string";
  if (/^<\/?[A-Za-z]/.test(token) || token === ">" || token === "/>") return "tag";
  if (/^\d/.test(token)) return "number";
  if (codeKeywords.has(token)) return "keyword";
  if (/^[{}()[\].,;:+\-*/%=<>!&|?]+$/.test(token)) return "operator";
  return "plain";
};

export const tokenizeCodeLine = (line) => {
  const text = String(line ?? "");
  const tokens = [];
  let lastIndex = 0;

  for (const match of text.matchAll(tokenPattern)) {
    if (match.index > lastIndex) {
      tokens.push({ kind: "plain", value: text.slice(lastIndex, match.index) });
    }
    tokens.push({ kind: getCodeTokenKind(match[0]), value: match[0] });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    tokens.push({ kind: "plain", value: text.slice(lastIndex) });
  }

  return tokens.length ? tokens : [{ kind: "plain", value: text }];
};
